import i18n from 'i18next';
import {
  renderUserRegistersAccessTypeCell
} from 'src/modules/users/components/UserRegistersAccessTypeCell';
import {renderUserRegistersAccessCategoryCell} from '@/modules/users/components/UserRegistersAccessCategoryCell';
import {renderUserRegistersAccessRegistersCell} from '@/modules/users/components/UserRegistersAccessRegistersCell';

export const usersRegistersAccessColumns =
    [
      {
        title: i18n.t('users:areaAccess'),
        dataIndex: 'areaAccess',
        key: 'areaAccess',
        render: renderUserRegistersAccessTypeCell,
      },
      {
        title: i18n.t('users:category'),
        dataIndex: 'category',
        key: 'category',
        render: renderUserRegistersAccessCategoryCell,
      },
      {
        title: i18n.t('users:registers'),
        key: 'registers',
        dataIndex: 'registers',
        render: renderUserRegistersAccessRegistersCell
      },
    ];